export * from "./EmbeddingSdkLegaleseModal";
